import { useQuery } from '@tanstack/react-query';
import { deviceApis } from '../../../../../../shared/apis/device/apis';
import type { IUnDispatchedListParams } from '../../../../../../shared/apis/device/shipment/types';
import { IDevice } from '../../Register/types';

export function useUnDispatched(payload: IUnDispatchedListParams) {
  const { data: unDispatched } = useQuery(
    ['getUnDispatchedList', payload.page, payload.mac, payload.channel],
    () => deviceApis.shipment.getUnDispatchedList(payload),
    {
      select: (data) => data.data,
    },
  );

  return {
    unDispatchedList: (unDispatched?.data as IDevice[]) || [],
    totalCount: unDispatched?.totalCount || 0,
  };
}
